/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { USER_TOKEN_INFO } from '@algomusinc/domain';
import { LocalstorageService } from '../config/localstorage.service';
import { EnvironmentService } from '../service/service.module';
@Injectable( {providedIn: 'root'} )
export class AuthService {
  environment = EnvironmentService.environment
  constructor(private http: HttpClient, private storage: LocalstorageService,) {}

  login(obj: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppAccount as string}/login`, obj);
  }
  loginClientBased(obj: any) {
    return this.http.post<any>(`${this.environment.AppAccount}/loginClientBased`, { Email: obj.Email, Password: obj.Password, ClientConfigurationId: obj.ClientConfigurationId, JWT: obj.JWT })
        .pipe(map(user => {
            return user;
        }));
}
  forgotPassword(email: string): Observable<any> {
    return this.http.post(`${this.environment.AppAccount as string}/forgotPassword`, { email });
  }

  resetPassword(obj: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppAccount as string}/resetpassword`, obj)
  }
  changePassword(obj: any): Observable<any> {
    return this.http.post<any>(`${this.environment.AppAccount as string}/changepassword`, obj);
  }
  logoutUser(obj: any): Observable<any> {
    return this.http.put<any>(`${this.environment.AppAccount as string}/UserLogout`, obj);
  }

  logout() {
    this.storage.remove(USER_TOKEN_INFO);
  }
}
